import React, { useState, useEffect } from "react";
import "../styles/quickddx.css";
import { FaAsterisk } from "react-icons/fa6";
import { toast } from "react-toastify";
import {
  useGetProfileQuery,
  useUpdateProfileMutation,
  useGetSubscriptionsQuery,
} from "../store/profile/UserApiSlice";
import app_api from "../config/Api";
import config from "../config/APIEndpoints";
import { data } from "autoprefixer";
import { FaArrowUpLong } from "react-icons/fa6";
import SubscriptionLoader from "./subscriptionloader";
const clipicon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/diagnose/clip.svg";
const FreeTrialIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/freepopup.svg";

const FreeTrialText =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/FreeTrialText!.svg";
const LogoWhite =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/logowhite.svg";
const BannerWomen =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/bannerwoman.svg";
const crossicon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/lounge/crossicon.svg";
export default function OrderSummary({ isVisible, onClose, onClaim }) {
  const [PaymentComplete, setPayComplete] = useState(false);
  const [paymentKeyword, setPaymentKeyword] = useState(false);
  const [paymentSuceess, setPaymentSuccess] = useState(false);
  function loadScript(src) {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  }
  useEffect(() => {
    loadScript("https://checkout.razorpay.com/v1/checkout.js");
  }, []);

  const { data: profileData, refetch } = useGetProfileQuery();

  const paymentInit = (data) => {
    const options = {
      key: process.env.REACT_APP_RZP_KEY_ID,
      amount: data.amount,
      subscription_id: data.subId,
      currency: data.currency,
      name: "NeuroGen",
      description: "",
      image: "/logo.png",
      handler: async function (response) {
        try {
          toast.success("Payment Successful");
          setPaymentSuccess(true);
        } catch (error) {
          toast.error("Payment Failed");
        }
      },
      prefill: {
        name: `${profileData?.profile?.first_name} ${profileData?.profile?.last_name}`,
        email: profileData?.profile?.email,
        contact: profileData?.profile?.phone_number,
      },
      theme: {
        color: "#0D304F",
      },
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
  };
  useEffect(() => {
    if (paymentSuceess) {
      setPayComplete(true);
    }
  }, [paymentSuceess]);
  const [initPayment, setInitPayment] = useState(false);
  const togglePaymentComeplete = () => {
    setPayComplete(!PaymentComplete);
  };
  const initSubscription = async (id, amount, currency) => {
    setPaymentKeyword(true);
    try {
      setInitPayment(true);
      const res = await app_api.post("/api/v1/createsubscription/", {
        plan_id: id,
        plan_type: "trial",
      });
      paymentInit({
        amount: Number(amount),
        currency: currency,
        subId: res.data.subscription.id,
      });
    } catch (error) {
      toast.error("Payment Failed");

      console.log(error);
    } finally {
      setPaymentKeyword(false);
      setInitPayment(false);
    }
  };
  const { data: dummyPlans } = useGetSubscriptionsQuery();
  const basic_plan = dummyPlans?.plans?.find(
    (plan) => plan.plan_name === "1 Month"
  );
  if (!isVisible) return null;
  return (
    <>
      {" "}
      <SubscriptionLoader
        isVisible={PaymentComplete}
        onClose={togglePaymentComeplete}
        header="Claiming Offer"
      />
      {!PaymentComplete && (
        <div className="popup-overlay">
          <div className="ordersummary">
            <h3>Order Summary</h3>

            <div className="ordertotal">
              <div className="orderttotalelement">
                <h5>Subtotal</h5>
                <h5>₹249.00</h5>
              </div>
              <div className="orderttotalelement">
                <h5>Discount</h5>
                <h5>
                  <s>₹249.00</s>
                </h5>
              </div>
              <hr />
              <div className="orderttotalelement">
                <h3>Total</h3>
                <div className="orderttotalelementleft">
                  {" "}
                  <h4>Immediately Refundable</h4>
                  <h3>₹5.00</h3>
                </div>
              </div>
              <hr />
              <div className="orderttotalelement"></div>
              <p className="ordertotaltextbox">
                Refundable ₹5 will be charged by Razorpay for confirmation.
                After 7 days, ₹249 will be charged. Cancel anytime within 7
                days.
              </p>
              <button
                onClick={() =>
                  initSubscription(
                    basic_plan.plan_id,
                    basic_plan.price,
                    basic_plan.plan_currency
                  )
                }
                className="min-w-80 hovereffect"
                type="button"
                disabled={initPayment}
              >
                {initPayment ? "Availing" : "Avail Offer"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
